// File: src/components/JobRequirements/MappedStudents/MappedFiltersSection.js

import React from 'react';
import Select from 'react-select';

const MappedFiltersSection = ({
    filters,
    statusCounts,
    branches,
    onFilterChange,
    onApplyFilters,
    onClearFilters
}) => {
    const statusOptions = [
        { value: 'all', label: 'All' },
        { value: 'Assigned', label: 'Assigned' },
        { value: 'Acknowledged', label: 'Acknowledged' },
        { value: 'Shortlisted', label: 'Shortlisted' },
        { value: 'Resume Not Shortlisted', label: 'Resume Not Shortlisted' },
        { value: 'Interview Scheduled', label: 'Interview Scheduled' },
        { value: 'Not Attended', label: 'Not Attended' },
        { value: 'Selected', label: 'Selected' },
        { value: 'Not Selected', label: 'Not Selected' },
        { value: 'Cancelled', label: 'Cancelled' },
        { value: 'Rejected By Student', label: 'Rejected By Student' },
    ];

    const acknowledgementOptions = [
        { value: '', label: 'All' },
        { value: 'Pending', label: 'Pending' },
        { value: 'Accepted', label: 'Accepted' },
        { value: 'Rejected', label: 'Rejected' },
        { value: 'Interview Accepted', label: 'Interview Accepted' }

    ];
    const placementInterestOptions = [
        { value: 'High', label: 'High' },
        { value: 'Medium', label: 'Medium' },
        { value: 'Low', label: 'Low' },
        { value: 'Critical', label: 'Critical' },
        { value: 'Non-Cooperative', label: 'Non-Cooperative' }
    ];
    const acknowledgementSelectOptions = acknowledgementOptions.map(opt => ({
        value: opt.value,
        label: opt.label
    }));

    const branchSelectOptions = branches.map(b => ({
        value: b.branch,
        label: b.branch
    }));

    return (
        <div className="mapped-filters-section">
            <h3 className="section-title">Filter Mapped Students</h3>

            {/* Current Status Filter Buttons */}
            <div className="status-filter-group">
                {statusOptions.map(option => (
                    <button
                        key={option.value}
                        onClick={() => onFilterChange('status', option.value)}
                        className={`status-filter-btn ${filters.status === option.value ? 'active' : ''}`}
                    >
                        {option.label} ({statusCounts[option.value] || 0})
                    </button>
                ))}
            </div>
            <div className="filters-grid">
                {/* Acknowledgement Status Filter Buttons */}
                <div className="filter-group">
                    <span className="filter-label">Acknowledgement Status</span>

                    <Select
                        isMulti
                        options={acknowledgementSelectOptions}
                        value={acknowledgementSelectOptions.filter(opt =>
                            filters.acknowledgementStatus.includes(opt.value)
                        )}
                        onChange={(selectedOptions) =>
                            onFilterChange(
                                'acknowledgementStatus',
                                selectedOptions ? selectedOptions.map(opt => opt.value) : []
                            )
                        }
                        className="react-select-container"
                        classNamePrefix="react-select"
                        placeholder="Select Acknowledgement Status"
                    />
                </div>
                {/* Branch Filter Dropdown */}
                <div className="filter-group">
                    <span className="filter-label">Branch</span>

                    <Select
                        isMulti
                        options={branchSelectOptions}
                        value={branchSelectOptions.filter(opt =>
                            filters.branch.includes(opt.value)
                        )}
                        onChange={(selectedOptions) =>
                            onFilterChange(
                                'branch',
                                selectedOptions ? selectedOptions.map(opt => opt.value) : []
                            )
                        }
                        className="react-select-container"
                        classNamePrefix="react-select"
                        placeholder="Select Branch"
                    />
                </div>
                <div className="filter-group">
                    <span className="filter-label">Student Name</span>

                    <input
                        type="text"
                        value={filters.studentName}
                        onChange={(e) => onFilterChange('studentName', e.target.value)}
                        placeholder="Search by student name..."
                        className="filter-input"
                    />
                </div>
                <div className="filter-group">
                    <span className="filter-label">Placement Interest</span>

                    <Select
                        isMulti
                        options={placementInterestOptions}
                        value={placementInterestOptions.filter(opt =>
                            filters.placementInterest.includes(opt.value)
                        )}
                        onChange={(selectedOptions) =>
                            onFilterChange(
                                'placementInterest',
                                selectedOptions
                                    ? selectedOptions.map(opt => opt.value)
                                    : []
                            )
                        }
                        className="react-select-container"
                        classNamePrefix="react-select"
                        placeholder="Select Placement Interest"
                    />
                </div>
                <div className="filter-group">
                    <span className="filter-label">From Date</span>

                    <input
                        type="datetime-local"
                        value={filters.fromDate}
                        onChange={(e) =>
                            onFilterChange('fromDate', e.target.value)
                        }
                        className="filter-input"
                    />
                </div>
                <div className="filter-group">
                    <span className="filter-label">To Date</span>

                    <input
                        type="datetime-local"
                        value={filters.toDate}
                        onChange={(e) =>
                            onFilterChange('toDate', e.target.value)
                        }
                        className="filter-input"
                    />
                </div>
            </div>

            {/* Action Buttons */}
            <div className="filter-actions">
                <button onClick={onApplyFilters} className="apply-filters-btn">
                    Apply Filters
                </button>
                <button onClick={onClearFilters} className="clear-filters-btn">
                    Clear Filters
                </button>
            </div>
        </div>
    );
};

export default MappedFiltersSection;